export function isEmailStringValid(email: string): boolean {
    return (/.+@.+\..+/g).test(email);
}

export function isStringTooLong(str: string, maxCharacters: number): boolean {
    return str.length > maxCharacters;
}
